import React, { Component } from 'react';
import { connect } from 'react-redux';
import { Grid , Header , Image , Popup , Button , Table , Icon } from 'semantic-ui-react';
import ThemeColorSetting from '../../constants/themeColor';
import sunmiDevice from '../../assets/sunmiDevice.gif';
import sunmiDeviceBack from '../../assets/sunmiDeviceBack.png';
import graphPaper from "../../assets/pattern/graph-paper.svg";

const styles = {
	coverContainer: {
    padding : '80px 0px',
    backgroundImage: 'url(' +graphPaper+ ')',
		backgroundColor: ThemeColorSetting.white,
		backgroundSize : '100px 100px',
		backgroundRepeat : 'repeat'
  },
  descriptionWrapper : {
    display : 'flex' ,
    flexDirection : 'column',
    justifyContent : 'center',
    padding : '5vh'
  },
  description : {
    fontSize : '20px',
    color : ThemeColorSetting.black,
    lineHeight: '200%'
  },
  imageWrapper : {
    display : 'flex' ,
    alignItems : 'center' ,
    justifyContent : 'center'
  },
  header : {
    fontSize : '50px',
		color : '#f37030'
  },
	frontImage : {
		width : '65%'
	},
	backImage : {
		width : '80%'
	},
	sunmiDevice : {
    width : '50%',
    height : '100%',
    display : 'flex',
    alignItems : 'center',
    justifyContent : 'center'
	}
}

class SunmiPitch extends Component {
	constructor(props){
		super(props);
		let isMobile = false;
		if (/Android|webOS|iPhone|iPod|BlackBerry|BB|PlayBook|IEMobile|Windows Phone|Kindle|Silk|Opera Mini/i.test(navigator.userAgent)) {
			isMobile = true;
		};
		this.state = { isMobile : isMobile };
	}
	render(){
		const { string } = this.props;
		const { isMobile } = this.state;
		return (
      <Grid.Row columns='2' style={styles.coverContainer}>
        <Grid.Column style={styles.imageWrapper}>
          <div style={styles.sunmiDevice}>
						{(!isMobile) ? <Popup
							trigger={
								<Button 
									color="black" 
									circular 
									icon='print' 
									style={{ position : 'relative' , zIndex : 1 , left : 10 , top : -180  }}
							/>}
							content={string['sunmiPrinter']}
							inverted
						/> : null}
						<Image src={sunmiDevice} style={styles.frontImage}/>
						{(!isMobile) ? <Popup
							trigger={
								<Button 
									color="olive" 
									circular 
									icon='android' 
									style={{ position : 'relative' , zIndex : 1 , left : -10   }}
							/>}
							content={string['sunmiAndroid']}
							inverted
						/> : null}
					</div>
					<div style={styles.sunmiDevice}>
						{(!isMobile) ? <Popup
							trigger={
								<Button 
									color="black" 
									icon='volume up' 
									circular style={{ position : 'relative' , zIndex : 1 , left : 15, top : 50  }}
							/>}
							content={string['sunmiVolumeShortcut']}
							on='hover'
							inverted
						/> : null }
						<Image src={sunmiDeviceBack} style={styles.backImage}/>
						{(!isMobile) ? <Popup
							trigger={
								<Button 
									color="grey" 
									icon='camera' 
									circular 
									style={{ position : 'relative' , zIndex : 1 , left : -100, top : -40  }}
							/>}
							content={string['sunmiCamera']}
							on='hover'
							inverted
						/> : null }
					</div>
        </Grid.Column>
        <Grid.Column style={styles.descriptionWrapper}>
          <Header as='h1' style={styles.header}>{string['pitch0Header']}</Header>
          <p style={styles.description}>{string['pitch0Content']}</p>
					<Table basic='very' celled>
						 <Table.Body>
							 <Table.Row textAlign='center'>
								 <Table.Cell>
									<Header as='h3' icon color='grey'>
										<Icon name='android' />
										{string['sunmiAndroidVer']}
									</Header>
								 </Table.Cell>
								 <Table.Cell>
									<Header as='h3' icon color='grey'>
										<Icon name='mobile' />
										{string['sunmiScreen']}
									</Header>
								 </Table.Cell>
								 <Table.Cell>
									<Header as='h3' icon color='grey'>
										<Icon name='battery full' />
										{string['sunmiBattery']}
									</Header>
								 </Table.Cell>
							</Table.Row>
							<Table.Row textAlign='center'>
							 <Table.Cell>
								<Header as='h3' icon color='grey'>
									<Icon name='print' />
									{string['sunmiPrint']}
								</Header>
							 </Table.Cell>
							 <Table.Cell>
								<Header as='h3' icon color='grey'>
									<Icon name='qrcode' />
									{string['sunmiCamera']}
								</Header>
							 </Table.Cell>
							 <Table.Cell>
								<Header as='h3' icon color='grey'>
									<Icon name='wifi' />
									{string['sunmiConnect']}
								</Header>
							 </Table.Cell>
							</Table.Row>
						</Table.Body>
					</Table>
				</Grid.Column>
			</Grid.Row>
		)
	}
}

function mapStateToProps(state){
	return {
		string : state.preference.string
	}
}

export default connect(mapStateToProps,null)(SunmiPitch)



/** WEBPACK FOOTER **
 ** ./src/containers/pitch/sunmiPitch.js
 **/